module.exports = __webpack_public_path__ + "img/ef-logo-desktop.d0eedc35.svg";